import { Enums } from "../common/enums"
import { OpPacket } from "./op-packet"

import { ICopyable, IOpChangeState } from "../util/interfaces"

export class OpActionPacket implements IOpChangeState, ICopyable<OpActionPacket> {

    //#region Properties

    public idAction: number
    public idPacket: number

    //#endregion


    //#region Navigation properties

    public packet: OpPacket

    //#endregion

    //#region Custom properties

    public opState: Enums.OpChangeState

    //#endregion


    //#region Ctor

    constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    //#endregion

    public toString(): string {
        //as on backEnd
        return `ActionPacket [${this.idAction}]`
    }

    //#endregion

    //#region IJsonSerializer Implementation

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj != null) {
            this.idAction = opObj.ID_ACTION
            this.idPacket = opObj.ID_PACKET
            this.opState = opObj.OpState
            this.packet = (opObj._Packet != null) ? new OpPacket(opObj._Packet) : null
        }
    }

    public toJSON(compressed: boolean = false): any {
        return {
            ID_ACTION: this.idAction,
            ID_PACKET: this.idPacket,
            OpState: this.opState,
            _Packet: (this.packet != null) ? this.packet.toJSON(compressed) : null
        }
    }

    //#endregion

    //#region ICopyable Implementation

    public clone(includeNavigationProperties: boolean = false, includeCustomProperties: boolean = false, includeDataList: boolean = false, includeDynamicValues: boolean = false): OpActionPacket {
        const newActionPacket: OpActionPacket = new OpActionPacket(null)

        newActionPacket.copy(this, includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues)

        return newActionPacket
    }

    public copy(source: OpActionPacket, includeNavigationProperties: boolean = false, includeCustomProperties: boolean = false, includeDataList: boolean = false, includeDynamicValues: boolean = false): void {
        if (source == null) {
            return
        }

        if (includeNavigationProperties) {
            if (source.packet != null) {
                const packet: OpPacket = new OpPacket(null)
                packet.copy(source.packet, true, true)

                this.packet = packet
            }
        }

        if (includeCustomProperties) {

        }

        if (includeDataList) {
            //no dataList
        }

        if (includeDynamicValues) {
            //no dynamic values
        }

        this.idAction = source.idAction
        this.idPacket = source.idPacket

        this.opState = source.opState
    }

    //#endregion

}